import {EventEmitter, Injectable, ViewChild} from '@angular/core';
import {HttpService} from './http.service';
import {Router} from '@angular/router';
import {Attendant, LoginUser, User} from '../auth/user.object';

declare var swal: any;

@Injectable()
export class AuthService {
  private userToken = '';
  private token = '';
  public isloggedin: boolean;
  public AuthenticatedUserEmmitter = new EventEmitter<User>();
  public RegistrationEmmitter = new EventEmitter<User>();

  constructor(private httpService: HttpService, private router: Router) {

  }

  public isAdminAuthenticated(): boolean {
    const token = localStorage.getItem('melkamwetat_user_token');
    return true;
  }
  public isAgentAuthenticated(): boolean {
    const token = localStorage.getItem('melkamwetat_user_token');
    return this.isAgentAccount();
  }

  public CheckIfLoggedIn(): boolean {
    this.token = localStorage.getItem('melkamwetat_user_token');
    if (this.token === null) {
      this.token = '1';
    }
    if (this.token.length > 10) {
      this.isloggedin = true;
      return true;
    } else if (this.token.length === null || this.token.length < 10) {
      this.isloggedin = false;
      return false;
    }
  }


  private processCheckTokenValidity(response) {
    if (response && response.user) {
      return true;
    } else {
      this.router.navigate(['/auth/login']);
    }
  }


  public authenticate(user: LoginUser) {
    console.log('auth->', user);
    const header = new Headers();
    this.httpService.sendPostRequest('user/authenticate', user, header)
      .subscribe(
        data => {
          console.log('auth-response', data);
          this.processAuthenticateResponse(data)
        },
        error => {
          console.log('auth-error', error);
          swal('Wrong credentials', error.error, 'error')
        });
  }

  private processAuthenticateResponse(response) {
    if (response && response.user) {
      localStorage.setItem('role_id', response.user.role_id);
      localStorage.setItem('melkamwetat_user_token', response.token);
      localStorage.setItem('melkamwetat_user_full_name', response.user.full_name);
      localStorage.setItem('melkamwetat_account_type', response.user.role_id);
      this.AuthenticatedUserEmmitter.emit(response.user);
    }
  }

  public register(user: Attendant) {
    console.log('auth->', user);
    const header = new Headers();
    return this.httpService.sendPostRequest('attendant', user, header);
  }

  private processRegistrationResponse(response) {
    if (response && response.user) {
      this.RegistrationEmmitter.emit(response.user);
    }
  }

  public isAgentAccount(): boolean {
    if (localStorage.getItem('melkamwetat_account_type')) {
      if (localStorage.getItem('melkamwetat_account_type') === '2') {
        return true;
      }
    }
    return false;
  }

  public isAdminAccount(): boolean {
    console.log("Role ID " +localStorage.getItem('role_id'));
    if (localStorage.getItem('melkamwetat_account_type')) {
      if (localStorage.getItem('melkamwetat_account_type') === '1') {
        return true;
      }
    }
    return false;
  }

  public getUserToken() {
    return localStorage.getItem('melkamwetat_user_token');
  }
  public getUserFullName() {
    return localStorage.getItem('melkamwetat_user_full_name');
  }

  public getAccountName() {
    return localStorage.getItem('melkamwetat_account_name');
  }
  public logOut() {
    localStorage.setItem('role_id', '0');
    localStorage.setItem('melkamwetat_user_token', '');
    localStorage.setItem('melkamwetat_account_type', '0');
    this.router.navigate(['/auth/login']);
  }

  public isSuperAdmin() {
    if (localStorage.getItem('role_id')) {
      if (localStorage.getItem('role_id') === '1') {
        return true;
      }
    }
    return false;
  }

  public isAdmin() {
    if (localStorage.getItem('role_id')) {
      if (localStorage.getItem('role_id') === '2') {
        return true;
      }
    }
    return false;
  }

  public isEditor() {
    if (localStorage.getItem('role_id')) {
      if (localStorage.getItem('role_id') === '3') {
        return true;
      }
    }
    return false;
  }

  public isAttendant() {
    if (localStorage.getItem('role_id')) {
      if (localStorage.getItem('role_id') === '4') {
        return true;
      }
    }
    return false;
  }

  public isSuperAdminOrAdmin() {

    if (this.isSuperAdmin() || this.isAdmin()) {
        return true;
    }
    return false;
  }

  public isSuperAdminAdminEditor() {

    if (this.isSuperAdmin() || this.isAdmin() || this.isEditor()) {
      return true;
    }
    return false;
  }


}



// WEBPACK FOOTER //
// ./src/app/services/auth.service.ts